import React from 'react';
import PropTypes from 'prop-types';

const ContextQuestionPrint = ({ question, answers }) => {
  const renderParagraph = (text) => (
    <div
      className="ml3 w-90 ba"
      style={{ maxHeight: '100%', minHeight: '4rem' }}
    >
      <p className="b i f6 ma0 pa2">{text}</p>
    </div>
  );

  const renderMultipleChoice = (checked) => (checked
    ? <span>&#128505;</span>
    : <span>&#9634;</span>);

  const renderSingleChocie = (checked) => (checked ? <span style={{ fontSize: '1.5em' }}>&#10687;</span> : <span>&#9711;</span>);

  const renderOptions = () => question.options.map((option) => {
    let checked = false;
    if (answers) {
      checked = answers.find((answer) => answer.answer === option.answer.uuid);
    }

    return (
      <div
        key={option.answer.uuid}
      >
        {question.type.toLowerCase() === 'multiplechoice'
          ? renderMultipleChoice(checked)
          : renderSingleChocie(checked)}
        <span className="pl2">{option.answer.text}</span>
        <span className="pl2">{option.detailQuestion && `(${option.detailQuestion.text})`}</span>
        {
            (!checked || !checked.detailQuestion)
            && option.detailQuestion
            && renderParagraph(checked && checked.detailQuestionAnswer)
          }
      </div>
    );
  });

  return (
    <div
      key={question.id}
      className="pv2"
    >
      <div className="b">{question.question.text}</div>
      {question.options
        ? renderOptions()
        : renderParagraph(answers && answers.answer)}
    </div>
  );
};

export default ContextQuestionPrint;

ContextQuestionPrint.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    options: PropTypes.object,
  }).isRequired,
  answers: PropTypes.object.isRequired,
};
